import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created — welcome to KKashigari");
      navigate("/account");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-[80vh] grid place-items-center px-5 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-10"><Logo className="h-16 mx-auto" /></div>
        <h1 className="font-serif text-4xl text-[var(--bronze)] text-center">Create Account</h1>
        <p className="text-center text-[var(--olive)] mt-2">Join the KKashigari family</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Full Name</label>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          {err && <p data-testid="register-error" className="text-sm text-[var(--maroon)]">{err}</p>}
          <button type="submit" disabled={loading} data-testid="register-submit" className="btn-primary w-full uplabel py-4 disabled:opacity-60">{loading ? "Creating…" : "Create Account"}</button>
        </form>
        <p className="text-center text-sm text-[var(--olive)] mt-6">
          Already have an account? <Link to="/login" className="text-[var(--bronze)] link-underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
